import React from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
import "./ChartStyles.css"; // Importing custom CSS for styling

const QuizBarChart = ({ sdata }) => {
  const formattedData = sdata.map(item => ({
    name: item.SubCategoryName,
    TotalQuizzes: item.TotalQuizzes,
    Completed: item.TotalCompletedQuizzes,
    Incomplete: item.TotalQuizzes - item.TotalCompletedQuizzes,
  }));

  return (
    <div>
        <h2 className="chart-title">Graph By Subcategory</h2>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={formattedData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <XAxis dataKey="name" className="axis-label" />
            <YAxis className="axis-label" />
            <Tooltip cursor={{ fill: "#f5f5f5" }} />
            <Legend />
            <Bar dataKey="TotalQuizzes" fill="#8884d8" radius={[10, 10, 0, 0]} />
            <Bar dataKey="Completed" fill="#82ca9d" radius={[10, 10, 0, 0]} />
            <Bar dataKey="Incomplete" fill="#ffc658" radius={[10, 10, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
  );
};

export default QuizBarChart;
